import React from 'react'
import './Checkbox.css'
export function Checkbox(props) {
	return (
		<div className='field-group checkbox-group'>
			<label>
			    <input type="checkbox" {...props}/>
                {props.label} {props.required ? '*' : ''}
            </label>
            {
                props?.description && 
                <p>{props.description}</p>
            }
		</div>
	)
}
